import { FC, useEffect, useState } from 'react';
import { FormikHelpers } from 'formik';
import { CreateAddressInput } from 'lib/home/generated/types/api';
import { ShippingAddressFormModal, ShippingAddressFormModalProps } from './ShippingAddressFormModal';
import { useShippingAddressCreateMutation } from '../../ShippingAddress/ShippingAddress.hooks';

export interface CreateShippingAddressModalProps
  extends Omit<ShippingAddressFormModalProps<CreateAddressInput>, 'onSubmit'> {}

export const CreateShippingAddressModal: FC<CreateShippingAddressModalProps> = ({ isOpen, ...props }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const addMutation = useShippingAddressCreateMutation({
    onSuccess: () => setIsModalOpen(false)
  });

  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  const handleSubmit = (values: CreateAddressInput, formikHelpers: FormikHelpers<CreateAddressInput>) =>
    addMutation.mutate({ createAddressInput: values });

  return (
    <ShippingAddressFormModal<CreateAddressInput>
      {...props}
      id="create-shipping-address-modal"
      isOpen={isModalOpen}
      onSubmit={handleSubmit}
      data-cy="create-shipping-address-modal"
    />
  );
};
